/**
 * Module dependencies.
 */

import React from 'react';

/**
 * `FormError` type.
 */

type FormError = {
  type: string;
  message: string;
};

/**
 * `Props` type.
 */

type Props = {
  error: FormError;
  isVisible: boolean | undefined;
};

/**
 * Export `ErrorField` component.
 */

export function ErrorField({ error, isVisible }: Props): JSX.Element {
  // Always reserve the message row so focusing/blurring a field never shifts the
  // content below it; the message only shows once the field is touched/invalid.
  return (
    <span className={'block min-h-[1.125rem] pt-1 text-xs font-medium text-[#f77777]'}>
      {isVisible ? error?.message : null}
    </span>
  );
}
